import type { DeliveryStatus } from '../model/schema';

/**
 * The visual tone a status renders as, kept as a token key (never a hex) so the
 * status badge + filter dots map it to token-backed utilities. Each tone lines
 * up with a semantic color role. The mapping mirrors the Figma dot colors on
 * the status-filter row (node 236:7308):
 *
 *   planned    → sky        Запланирован
 *   searching  → orange     Поиск курьера
 *   notFound   → neutral    Не найдено
 *   active     → violet     Текущие
 *   returned   → pink       Возвращено
 *   completed  → green      Завершенные
 *   cancelled  → red        Отменено
 */
export type DeliveryTone =
  | 'sky'
  | 'orange'
  | 'neutral'
  | 'violet'
  | 'pink'
  | 'green'
  | 'red';

const TONE_BY_STATUS: Record<DeliveryStatus, DeliveryTone> = {
  planned: 'sky',
  searching: 'orange',
  notFound: 'neutral',
  active: 'violet',
  returned: 'pink',
  completed: 'green',
  cancelled: 'red',
};

export function deliveryStatusTone(status: DeliveryStatus): DeliveryTone {
  return TONE_BY_STATUS[status];
}

/** i18n key (under the `delivery` namespace) for a status's label. */
export function deliveryStatusLabelKey(status: DeliveryStatus): string {
  return `orders.status.${status}`;
}

/**
 * The canonical ordering of the status tabs on the Доставка screen — matches
 * the pill row left→right. `all` is the leading "Все" pill (no status filter).
 */
export const DELIVERY_STATUS_TABS = [
  'all',
  'planned',
  'searching',
  'notFound',
  'active',
  'returned',
  'completed',
  'cancelled',
] as const;

export type DeliveryStatusTab = (typeof DELIVERY_STATUS_TABS)[number];
